import helpers from '../helpers';

let count = 0;
const $test = $('.test');
const $step = $test.find('.test__step');
const $result = $test.find('.test__result');
const $button = $test.find('.js-test-btn');
const $answer = $test.find('.js-test-answer');

function repeat() {
	$step.removeClass('is-active is-done').addClass('is-hidden');
	$step.filter('.test__step--1').addClass('is-active');
	$result.removeClass('is-active').addClass('is-hidden');
	$answer.removeClass('is-right is-wrong');
	$('.test__header').add('.test__content').add('.test__footer').show();
	count = 0;

	helpers.$document.trigger('analytics-test-resume');
}

function result() {
	$step.removeClass('is-active').addClass('is-hidden');
	$('.test__header').add('.test__content').add('.test__footer').hide();
	$result.removeClass('is-hidden').addClass('is-active');

	const text = $result.find('.test__result-title').text();

	helpers.$document.trigger('analytics-test-finish', [text, count]);
}

function next() {
	const $activeStep = $step.filter('.is-active');
	const $nextStep = $activeStep.next('.test__step');

	if (!$nextStep.length) {
		result();

		return;
	}

	$activeStep.removeClass('is-active').addClass('is-hidden');
	$nextStep.removeClass('is-hidden').addClass('is-active');

	const num = $nextStep.data('step');
	const name = $nextStep.find('.test__text').text();
	helpers.$document.trigger('analytics-test-question-show', [num, name]);
}

function changeState(e) {
	e.preventDefault();
	e.stopPropagation();

	const type = e.currentTarget.dataset.step;

	if (type === 'next') {
		next();
	} else if (type === 'repeat') {
		repeat();
	} else {
		return;
	}

	helpers.scrollTo($test);
}

function selectAnswer(e) {
	const $currentAnswer = $(e.currentTarget);
	const $currentStep = $currentAnswer.closest('.test__step');
	const $currentAnswers = $currentStep.find('.js-test-answer');
	const $currentStepBtn = $currentStep.find('.js-test-btn');

	if ($currentStep.hasClass('is-done')) {
		return;
	}

	$currentAnswers.addClass('is-hide');
	$currentStep.addClass('is-done');
	$currentAnswer.next().slideDown();
	$currentStepBtn.removeClass('is-hidden');

	if ($currentAnswer.hasClass('is-correct')) {
		$currentAnswer.addClass('is-right');
		count += 1;
	} else {
		const $correctAnswer = $currentAnswer.siblings('.test__answer.is-correct');

		$currentAnswer.addClass('is-wrong');
		$correctAnswer.addClass('is-right');
		$currentAnswers.filter('.is-correct').addClass('is-right');
	}

	const answer = $currentAnswer.hasClass('is-correct') ? 'Yes' : 'No';
	const num = $currentStep.data('step');
	const name = $currentStep.find('.test__text').text();

	helpers.$document.trigger('analytics-test-question-answer', [num, answer, name]);
	helpers.scrollTo($currentStep);
}

function init() {
	const num = $('.test__step--1').data('step');
	const name = $('.test__step--1').find('.test__text').text();

	helpers.$document.trigger('analytics-test-start');
	helpers.$document.trigger('analytics-test-question-show', [num, name]);

	$button.on('click.test', changeState);
	$answer.on('click.test', selectAnswer);
}

init();
